import { formatDate } from "./formatDate";
import { formatTime } from "./formatTime";

export function formatDatetime(date: Date | string) {
  const dateObj = date instanceof Date ? date : new Date(date);

  return `${formatDate(dateObj)} ${formatTime(dateObj)}`;
}
